export const META_INFO = {
  '/': {
    title: 'Website Builder for cPanel, Plesk and WHMCS',
    description:
      'Give your customers a website builder designed for cPanel, Plesk and WHMCS.',
  },
  '/website-builder': {
    title: 'Build a Website with Siteplus',
    description:
      'Start building your website today with simple drag and drop, anyone can build.',
  },
  '/demo': {
    title: '',
    description: '',
  },
  '/simple-integration': {
    title: 'Simple Integration Using API or Website Builder Plugins',
    description:
      'A Website Builder platform designed for hosting providers with cPanel, WHMCS, Plesk and API integration.',
  },
  '/online-store': {
    title: 'Build Your Own Online Store ',
    description:
      'Siteplus ecommerce platform has everything you need to sell online, on social media, or in person.',
  },
  '/customer-manager': {
    title: 'Website Builder for Hosting Providers',
    description:
      "Build and sell websites today with Siteplus's drag and drop, responsive website builder.",
  },
  '/features': {
    title: 'Features - Siteplus Website Builder',
    description:
      'Siteplus gives you all the features you need to build your own website and online store.',
  },
  '/templates': {
    title: 'Website Templates for Every Business',
    description:
      'Choose from over 100+ website templates designed by professionals for every industry.',
  },
  '/templates/beauty': {
    title: 'Beauty Website Templates',
    description:
      'Choose from over 100+ website templates designed by professionals for every industry.',
  },
  '/templates/business': {
    title: 'Business Website Templates',
    description:
      'Choose from over 100+ website templates designed by professionals for every industry.',
  },
  '/templates/health': {
    title: 'Healthcare Website Templates',
    description:
      'Choose from over 100+ website templates designed by professionals for every industry.',
  },
  '/templates/personal': {
    title: 'Personal Website Templates',
    description:
      'Choose from over 100+ website templates designed by professionals for every industry.',
  },
  '/templates/portfolio': {
    title: 'Portfolio Website Templates',
    description:
      'Choose from over 100+ website templates designed by professionals for every industry.',
  },
  '/templates/restaurant': {
    title: 'Restaurant Website Templates',
    description:
      'Choose from over 100+ website templates designed by professionals for every industry.',
  },
  '/templates/services': {
    title: 'Services Website Templates',
    description:
      'Choose from over 100+ website templates designed by professionals for every industry.',
  },
  '/about-us': {
    title: 'About - Siteplus Website Builder',
    description:
      'Learn how Siteplus has become a world-leading Website Builder platform.',
  },
  '/register': {
    title: 'Register to the Siteplus Reseller Program',
    description: 'Engage your customers with your own website builder.',
  },
  '/contact': {
    title: 'Contact - Siteplus Website Builder',
    description: 'Contact Siteplus to schedule a demo with an Account Manager.',
  },
  '/checkout': {
    user: {
      title: 'Buy your Siteplus Personal Plan',
      description:
        'Buy your Siteplus Personal plan and get access to everything your website will ever need.',
    },
    partner: {
      title: 'Buy your Siteplus Reseller Membership',
      description:
        'Join the Siteplus Reseller Program and start a website builder business.',
    },
  },
  '/help': {
    title: 'Help Center - Siteplus Website Builder',
    description: 'Gain insights into using Siteplus Website Builder',
  },
  '/legal/terms': {
    title: 'Terms and Conditions - Siteplus Website Builder',
    description:
      'Siteplus gives you all the features you need to build your own website and online store.',
  },
  '/legal/privacy': {
    title: 'Privacy Policy  - Siteplus Website Builder',
    descriptios:
      'Siteplus gives you all the features you need to build your own website and online store.',
  },
  '/legal/gdpr': {
    title: 'GDPR - Siteplus Website Builder',
    description:
      'Start building your website today with simple drag and drop, anyone can build.',
  },
  '/404': {
    title: 'Page Not Found',
    description: "We can't find the page you're looking for.",
  },
  '/about-us/our-values': {
    title: 'Values - Siteplus Website Builder',
    description:
      'Together at Siteplus we have come up with our own company values we stand for.',
  },
  '/about-us/our-lifestyle': {
    title: 'Our Lifestyle - Siteplus Website builder',
    descrition:
      'View our the exciting career opportunities now open at Siteplus!',
  },
  '/login': {
    title: 'Login - Siteplus Website Builder',
    description:
      'Choose from hundreds of website templates and edit everything with Drag & Drop. Its so simple anyone can build.',
  },
  '/login/recovery': {
    title: 'Reset Your Password',
  },
  '/login/password-reset': {
    title: 'Reset Your Password',
  },
  '/login/success': {
    title: 'Password Reset Successful',
  },
};

export const getMeta = (pathname) => META_INFO[pathname] || {};
